import store from "@utils/redux/store";
import {
  setUserProperties,
  saveMainSurveyAnswers,
  savePurchaseSurveyAnswers,
  saveProfile,
  saveCareersNewsletter,
  saveExperiment,
  updateUserData,
} from "@utils/redux/slices/userData";

/**
 * UserData stub that maps to Redux.
 * This stub, to be attached to `window.userData` stubs out the old UserData
 * service.
 */
class UserData {
  get _data() {
    console.warn("window.userData is deprecated. Please use Redux.");
    const { userData } = store.getState();
    return userData;
  }

  set _data(data) {
    console.warn("window.userData is deprecated. Please use Redux.");
    store.dispatch(updateUserData(data));
  }

  get _userDataLoaded() {
    return new Promise(resolve => resolve(this._data));
  }

  set _userDataLoaded(_) {
    console.warn("Do not set _userDataLoaded.");
  }

  _loadUserData() {
    return this._userDataLoaded;
  }

  setProperties(props) {
    store.dispatch(setUserProperties(props));
  }

  saveMainSurvey(props) {
    store.dispatch(saveMainSurveyAnswers(props));
  }

  savePurchaseSurvey(props) {
    store.dispatch(savePurchaseSurveyAnswers(props));
  }

  saveProfile(props) {
    store.dispatch(saveProfile(props));
  }

  saveCareersNewsletter(props) {
    store.dispatch(saveCareersNewsletter(props));
  }

  saveExperiment(props) {
    store.dispatch(saveExperiment(props));
  }
}

export default UserData;
